module.exports = __webpack_public_path__ + "img/img_greengd@2x.0ba29f9a.png";